<template>
<div>
<li v-for="(menuItem, mi) in menuItems" class="menu-item" :class="{'current-menu-item': menuItem.active}" v-if="!menuItem.loggedIn || loggedIn">
  <a :href="resolvedLink(menuItem.link)" v-on:click.prevent="clickItem(menuItem)" class="elementor-item" :class="{'elementor-item-active': menuItem.active}">
    {{ menuItem.title }}
  </a>
</li>
<slot />
</div>
</template>
<script>
export default {
  props: ["menuItems"],
  computed: {
    loggedIn() {
      return appRoot.loggedIn;
    },
  },
  methods: {
    clickItem(item) {
      if (typeof(item.link)=="string")
        window.open(item.link, "_self");
      if (item.action) {
        this.$emit('action', {name: item.action, args: item.args});
      } else if (item.link) {
        if (typeof(item.link)=="string" && item.link.indexOf("http")==0)
          window.open(item.link, "_self");
        else
          this.$router.push(item.link);
      }
    },
    resolvedLink(link) {
      if (typeof(link)=="string")
        return link;
      return this.$router.resolve(link).href;
    },
  },
}
</script>
